import { IRecommendation } from '@/interfaces/recommendation'
import { ConnectionRequestType, IUser } from '@/interfaces/user'

export const filterInvitationsSent = (
  reccoList: IRecommendation[],
  user: IUser
) => {
  if (typeof user?.invitationsSent !== 'undefined') {
    return reccoList.filter(
      (item) => !user?.invitationsSent.includes(item.email)
    )
  }
  return reccoList
}

export const getArryOfIdsFromConnection = (
  connections: ConnectionRequestType
) => {
  return connections?.map((connection) => {
    if (typeof connection === 'string') {
      return connection
    }
    return connection.userId
  })
}

export const validateConnectionExistsById = ({
  id,
  connections,
}: {
  id: string
  connections: ConnectionRequestType
}) => {
  return connections?.some((connection) => {
    if (typeof connection === 'string') {
      return connection === id
    }
    return connection.userId === id
  })
}
